// Per-user feature flags an admin can set in User Management (read with hasFeature).
export type FeatureFlag = 'lactate_testing' | 'mindbody_schedule';

// Builds the Firestore partial update for the given flags. Uses dotted field
// paths so each patches feature_flags.<flag> without clobbering other entries.
export function buildFeatureFlagUpdate(flags: Partial<Record<FeatureFlag, boolean>>): Record<string, boolean> {
  const update: Record<string, boolean> = {};
  (Object.keys(flags) as FeatureFlag[]).forEach((flag) => {
    const enabled = flags[flag];
    if (enabled !== undefined) update[`feature_flags.${flag}`] = enabled;
  });
  return update;
}
